/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowUseOfFundsItemDtoSchema } from "./dealflowUseOfFundsItemDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowInvestmentNeedDtoSchema = z.object({
  lookingFor: z.optional(z.string()),
  get useOfFunds() {
    return z.array(dealflowUseOfFundsItemDtoSchema).optional();
  },
});
